import theme from '../ui/theme';
import { generateColorPalette } from './colors';

export const CourseStates = {
  COMPLETED: 'completed',
  IN_PROGRESS: 'in_progress',
  REGISTERED: 'registered',
};

const CourseStatesColor = {
  registered: {
    label: 'Da iniziare',
    labelColor: '#ffffff',
    primary: theme().colors.emptyColor,
    secondary: 'rgba(255, 240, 186, 0.7)',
  },
  in_progress: {
    label: 'In corso',
    labelColor: '#ffffff',
    primary: theme().colors.incompleteColor,
    secondary: '#b5e6f4',
  },
  completed: {
    label: 'Completati',
    labelColor: '#ffffff',
    primary: theme().colors.completedColor,
    secondary: '#beddb9',
  },
  mandatory: {
    label: 'Obbligatori',
    labelColor: '#ffffff',
    primary: theme().colors.mandatory,
    secondary: '#d39eff',
  },
  empty: {
    label: '-',
    labelColor: '#FFFFFF',
    primary: theme().colors.transparent,
    secondary: theme().colors.transparent,
  },
};

export const getStateColor = (status) => CourseStatesColor[status] || {};

export const chartConfig = (data) => {
  const dataset = Object.keys(data).reduce(
    (obj, key) => ({
      ...obj,
      [key]: data[key],
    }),
    {}
  );
  delete dataset.total_courses;
  delete dataset.statType;

  const colors = Object.keys(dataset).map(
    (key) => getStateColor(key) && getStateColor(key).primary
  );

  return {
    dataset,
    total_items: data.total_courses,
    config: {
      labels: Object.keys(dataset).map((key) => getStateColor(key).label),
      datasets: [
        {
          data: Object.values(dataset),
          backgroundColor: colors,
          borderWidth: 4,
          borderRadius: 11,
        },
      ],
    },
  };
};

export const generalChartConfig = (data, dataLabels = false) => {
  const dataset = (dataLabels || Object.keys(data)).reduce(
    (obj, key) => ({
      ...obj,
      [key]: data[key],
    }),
    {}
  );

  const colors = (dataLabels || Object.keys(dataset)).map((key, i) => ({
    label: key,
    color:
      getStateColor(key) &&
      generateColorPalette((dataLabels || Object.keys(data))?.length)[i],
  }));

  const reducedColors = (Object.keys(dataset) || []).map(
    (key) => colors.find((c) => c?.label === key)?.color
  );

  return {
    dataset,
    config: {
      labels:
        dataLabels ||
        Object.keys(dataset).map((key) => getStateColor(key).label || key),
      datasets: [
        {
          data: Object.values(dataset),
          backgroundColor: reducedColors,
          borderWidth: 2,
          borderRadius: 8,
        },
      ],
    },
  };
};

export const barChartConfig = (data) => {
  const dataset = Object.keys(data).reduce(
    (obj, key) => ({
      ...obj,
      [key]: data[key],
    }),
    {}
  );

  const colors = Object.keys(dataset).map(
    (key, i) =>
      getStateColor(key) && generateColorPalette(Object.keys(data)?.length)[i]
  );

  return {
    dataset,
    labels: Object.keys(dataset).map((key) => getStateColor(key).label || key),
    datasets: [
      {
        data: Object.values(dataset),
        backgroundColor: colors,
        borderWidth: 0,
        borderRadius: 3,
      },
    ],
  };
};

export const barChartConfigWithTrend = (data) => {
  const dataset = Object.keys(data).reduce(
    (obj, key) => ({
      ...obj,
      [key]: data[key],
    }),
    {}
  );

  return {
    dataset,
    labels: Object.keys(dataset).map((key) => getStateColor(key).label || key),
    datasets: [
      {
        type: 'line',
        data: Object.values(dataset),
        backgroundColor: 'transparent',
        borderColor: '#0077CE',
        borderWidth: 1,
        tension: 0.4,
        pointRadius: 0,
      },
      {
        data: Object.values(dataset),
        backgroundColor: '#B2E5FF',
        borderWidth: 0,
        borderRadius: 3,
      },
    ],
  };
};

function findLongestObject(arrays) {
  let longestArray = {};

  for (let i = 0; i < arrays.length; i++) {
    if (Object.keys(arrays[i]).length > Object.keys(longestArray).length) {
      longestArray = arrays[i];
    }
  }

  return longestArray;
}

export const barChartConfigMultiSets = (data) => {
  if (!data || !Object.keys(data) > 0) return {};

  const datasetsLabels = Object.keys(
    findLongestObject(Object.values(data)) || {}
  );
  const datasets = [];

  const colors = generateColorPalette(datasetsLabels?.length);

  datasetsLabels.forEach((label, i) => {
    datasets.push({
      data: Object.values(data).map((item) => item[label]),
      backgroundColor: colors[i],
      borderWidth: 0,
      borderRadius: 3,
    });
  });

  return {
    labels: Object.keys(data),
    datasets,
  };
};

export const regionsProvinceLabels = [
  'Assegnazioni',
  'Fruizioni',
  'Completamenti',
];
